export enum RecipientType {
  PestControl = 1,
  Housekeeping = 2,
  PreventativeMaintenance = 3,
  MaintenanceRequest = 4
}
